module.exports = __webpack_public_path__ + "img/生活缴费.b73c8d74.png";